import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {OphButtonModule} from '../../../shared/design/oph-button/oph-button.module';
import {ListViewsModule} from '../../../shared/list-views/list-views.module';

@Component({
  selector: 'oph-dialog-footer',
  standalone: true,
  imports: [OphButtonModule, ListViewsModule, MatProgressSpinnerModule],
  templateUrl: './oph-dialog-footer.component.html',
  styleUrl: './oph-dialog-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OphDialogFooterComponent {
  @Input() loading: boolean;
  @Input() hideMenu: boolean;
  @Input() labels: {
    cancel?: string;
    save?: string;
  } = {
    cancel: 'Cancel',
    save: 'Save',
  };
  @Input() menuOptions: string[] = [];

  @Output() cancel = new EventEmitter();
  @Output() save = new EventEmitter();
  @Output() menuOption = new EventEmitter<(typeof this.menuOptions)[number]>();

  onMenu(type: (typeof this.menuOptions)[number]) {
    this.menuOption.emit(type);
  }
}
